import React, { useEffect, useState } from "react";
import { courseList, imageBaseUrl } from "../Api/ApiRoute";
import { css } from "@emotion/react";
import { ClipLoader } from "react-spinners";
import image1 from "../../src/images/slider-bg.jpg";
import { TagLine } from "../comman/constant";
import { Link } from "react-router-dom";
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;
const CompanyDetails = () => {
  document.title = "Aitsil SPV";
  const [courseData, setCourseData] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const initialCoursesToShow = 9;
  const [visibleCourses, setVisibleCourses] = useState(initialCoursesToShow);
  const [showAll, setShowAll] = useState(false);
  const [courseImage, setCourseImage] = useState();
  const [imageErrors, setImageErrors] = useState({});
  const getProfileImageSrc = (image, imageError) => {
    const apiImageUrl = `${imageBaseUrl}${image}`;
    const localImageUrl = image1;
    return imageError ? localImageUrl : apiImageUrl;
  };
  const handleImageError = (id) => {
    // Update the imageErrors state to mark the image as errored
    setImageErrors((prev) => ({
      ...prev,
      [id]: true,
    }));
  };

  useEffect(() => {
    fetchData();
    courseData?.map((course) => {
      return setCourseImage(course.course_image);
    });
  }, []);

  const toggleShowAll = () => {
    setShowAll(!showAll);
    setVisibleCourses(showAll ? initialCoursesToShow : courseData?.length);
  };

  const fetchData = () => {
    courseList({})
      .then((resp) => {
        setCourseData(resp?.data?.listOfCourse);
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setLoadingCourses(false);
      });
  };

  return (
    <>
      <section
        className="slider_section "
        style={{ width: "100%", height: "100px" }}
      >
        <div className="slider_bg_box">
          <img src={image1} alt="" />
        </div>
        {/* <div
          id="customCarousel1"
          className="carousel slide"
          data-ride="carousel"
        >
          <div className="carousel-inner ">
            <div className=" carousel-item active">
              <div className="container ">
                <div className="row">
                  <div className="col-md-7 ">
                    <div className="detail-box">
                      <h1>Vocational Training Programs</h1>
                      <p>
                        o Offering skill development courses in various sectors
                        like retail, IT, manufacturing, healthcare, and more,
                        aligned with industry standards.
                        <br />o Curriculum designed to cater to the practical
                        needs of the job market, making students job-ready.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <div className="container ">
                <div className="row">
                  <div className="col-md-7 ">
                    <div className="detail-box">
                      <h1>Placement Assistance</h1>
                      <p>
                        o Dedicated placement cell that works closely with
                        industry partners to facilitate job placements.
                        <br />o Organizing job fairs and campus recruitment
                        drives to connect trainees with potential employers.{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <div className="container ">
                <div className="row">
                  <div className="col-md-7 ">
                    <div className="detail-box">
                      <h1>Career Guidance and Counselling</h1>
                      <p>
                        o Providing students with career counseling to help them
                        choose the right training programs based on their
                        interests and market demand.
                        <br />o Offering support in resume building, interview
                        preparation, and soft skills development.{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <div className="container ">
                <div className="row">
                  <div className="col-md-7 ">
                    <div className="detail-box">
                      <h1>Government Initiative Partner</h1>
                      <p>
                        o As a training partner of PMKVY and JSDM, we align our
                        courses with national skill development initiatives to
                        support government efforts in improving employability.{" "}
                        <br />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ol className="carousel-indicators">
            <li
              data-target="#customCarousel1"
              data-slide-to={0}
              className="active"
            />
            <li data-target="#customCarousel1" data-slide-to={1} />
            <li data-target="#customCarousel1" data-slide-to={2} />
          </ol>
        </div> */}
      </section>

      {/* end hero-area */}
      {/*================================
  END HERO AREA
=================================*/}
      {/*======================================
  START FEATURE AREA
 ======================================*/}
      <section className="feature-area pb-20px">
        <div className="container">
          <div className="row feature-content-wrap">
            <div className="col-lg-3 responsive-column-half">
              <div className="info-box" style={{ height: 450 }}>
                <div className="info-overlay" />
                <div className="icon-element mx-auto shadow-sm">
                  <svg
                    className="svg-icon-color-1"
                    width={41}
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 490.667 490.667"
                    xmlSpace="preserve"
                  >
                    <g>
                      <g>
                        <path
                          d="M245.333,85.333c-41.173,0-74.667,33.493-74.667,74.667s33.493,74.667,74.667,74.667S320,201.173,320,160
                                          C320,118.827,286.507,85.333,245.333,85.333z M245.333,213.333C215.936,213.333,192,189.397,192,160
                                          c0-29.397,23.936-53.333,53.333-53.333s53.333,23.936,53.333,53.333S274.731,213.333,245.333,213.333z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M394.667,170.667c-29.397,0-53.333,23.936-53.333,53.333s23.936,53.333,53.333,53.333S448,253.397,448,224
                                          S424.064,170.667,394.667,170.667z M394.667,256c-17.643,0-32-14.357-32-32c0-17.643,14.357-32,32-32s32,14.357,32,32
                                          C426.667,241.643,412.309,256,394.667,256z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M97.515,170.667c-29.419,0-53.333,23.936-53.333,53.333s23.936,53.333,53.333,53.333s53.333-23.936,53.333-53.333
                                          S126.933,170.667,97.515,170.667z M97.515,256c-17.643,0-32-14.357-32-32c0-17.643,14.357-32,32-32c17.643,0,32,14.357,32,32
                                          C129.515,241.643,115.157,256,97.515,256z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M245.333,256c-76.459,0-138.667,62.208-138.667,138.667c0,5.888,4.779,10.667,10.667,10.667S128,400.555,128,394.667
                                          c0-64.704,52.629-117.333,117.333-117.333s117.333,52.629,117.333,117.333c0,5.888,4.779,10.667,10.667,10.667
                                          c5.888,0,10.667-4.779,10.667-10.667C384,318.208,321.792,256,245.333,256z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M394.667,298.667c-17.557,0-34.752,4.8-49.728,13.867c-5.013,3.072-6.635,9.621-3.584,14.656
                                          c3.093,5.035,9.621,6.635,14.656,3.584C367.637,323.712,380.992,320,394.667,320c41.173,0,74.667,33.493,74.667,74.667
                                          c0,5.888,4.779,10.667,10.667,10.667c5.888,0,10.667-4.779,10.667-10.667C490.667,341.739,447.595,298.667,394.667,298.667z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M145.707,312.512c-14.955-9.045-32.149-13.845-49.707-13.845c-52.928,0-96,43.072-96,96
                                          c0,5.888,4.779,10.667,10.667,10.667s10.667-4.779,10.667-10.667C21.333,353.493,54.827,320,96,320
                                          c13.675,0,27.029,3.712,38.635,10.752c5.013,3.051,11.584,1.451,14.656-3.584C152.363,322.133,150.741,315.584,145.707,312.512z"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <h3 className="info__title">Expand Training Programs</h3>
                <p className="info__text">
                  Introduce new training programs in emerging sectors like
                  digital marketing, AI, robotics, and green energy.
                </p>
              </div>
              {/* end info-box */}
            </div>
            <div className="col-lg-3 responsive-column-half">
              <div className="info-box" style={{ height: 450 }}>
                <div className="info-overlay" />
                <div className="icon-element mx-auto shadow-sm">
                  <svg
                    className="svg-icon-color-1"
                    width={41}
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 490.667 490.667"
                    xmlSpace="preserve"
                  >
                    <g>
                      <g>
                        <path
                          d="M245.333,85.333c-41.173,0-74.667,33.493-74.667,74.667s33.493,74.667,74.667,74.667S320,201.173,320,160
                                          C320,118.827,286.507,85.333,245.333,85.333z M245.333,213.333C215.936,213.333,192,189.397,192,160
                                          c0-29.397,23.936-53.333,53.333-53.333s53.333,23.936,53.333,53.333S274.731,213.333,245.333,213.333z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M394.667,170.667c-29.397,0-53.333,23.936-53.333,53.333s23.936,53.333,53.333,53.333S448,253.397,448,224
                                          S424.064,170.667,394.667,170.667z M394.667,256c-17.643,0-32-14.357-32-32c0-17.643,14.357-32,32-32s32,14.357,32,32
                                          C426.667,241.643,412.309,256,394.667,256z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M97.515,170.667c-29.419,0-53.333,23.936-53.333,53.333s23.936,53.333,53.333,53.333s53.333-23.936,53.333-53.333
                                          S126.933,170.667,97.515,170.667z M97.515,256c-17.643,0-32-14.357-32-32c0-17.643,14.357-32,32-32c17.643,0,32,14.357,32,32
                                          C129.515,241.643,115.157,256,97.515,256z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M245.333,256c-76.459,0-138.667,62.208-138.667,138.667c0,5.888,4.779,10.667,10.667,10.667S128,400.555,128,394.667
                                          c0-64.704,52.629-117.333,117.333-117.333s117.333,52.629,117.333,117.333c0,5.888,4.779,10.667,10.667,10.667
                                          c5.888,0,10.667-4.779,10.667-10.667C384,318.208,321.792,256,245.333,256z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M394.667,298.667c-17.557,0-34.752,4.8-49.728,13.867c-5.013,3.072-6.635,9.621-3.584,14.656
                                          c3.093,5.035,9.621,6.635,14.656,3.584C367.637,323.712,380.992,320,394.667,320c41.173,0,74.667,33.493,74.667,74.667
                                          c0,5.888,4.779,10.667,10.667,10.667c5.888,0,10.667-4.779,10.667-10.667C490.667,341.739,447.595,298.667,394.667,298.667z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M145.707,312.512c-14.955-9.045-32.149-13.845-49.707-13.845c-52.928,0-96,43.072-96,96
                                          c0,5.888,4.779,10.667,10.667,10.667s10.667-4.779,10.667-10.667C21.333,353.493,54.827,320,96,320
                                          c13.675,0,27.029,3.712,38.635,10.752c5.013,3.051,11.584,1.451,14.656-3.584C152.363,322.133,150.741,315.584,145.707,312.512z"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <h3 className="info__title">Reach More States</h3>
                <p className="info__text">
                  Expand our training network to additional states, increasing
                  accessibility to skill development opportunities.
                </p>
              </div>
              {/* end info-box */}
            </div>
            {/* end col-lg-3 */}
            <div className="col-lg-3 responsive-column-half">
              <div className="info-box" style={{ height: 450 }}>
                <div className="info-overlay" />
                <div className="icon-element mx-auto shadow-sm">
                  <svg
                    className="svg-icon-color-2"
                    viewBox="0 0 74 74"
                    width={45}
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m31.841 26.02a1 1 0 0 1 -.52-1.855l2.59-1.57a1 1 0 1 1 1.037 1.71l-2.59 1.57a1 1 0 0 1 -.517.145z" />
                    <path d="m57.42 58.09a.985.985 0 0 1 -.294-.045l-20.09-6.179a1 1 0 0 1 -.546-1.5l26.054-40.382-39.324 38.55a1 1 0 0 1 -1.087.208l-16.76-7.03a1 1 0 0 1 -.131-1.777l11.358-6.871a1 1 0 0 1 1.035 1.711l-9.675 5.853 14.334 6.013 39.106-38.341-20.363 12.316a1 1 0 0 1 -1.037-1.716l27.709-16.747a1 1 0 0 1 .372-.14s0 0 0 0a.986.986 0 0 1 .156-.013 1 1 0 0 1 .609.206l.079.067a1 1 0 0 1 .312.713 1.023 1.023 0 0 1 -.023.227l-10.814 54.073a1 1 0 0 1 -.98.8zm-18.533-7.747 17.769 5.466 9.572-47.844z" />
                    <path d="m23.221 31.23a1 1 0 0 1 -.519-1.856l2.53-1.53a1 1 0 0 1 1.036 1.712l-2.531 1.53a1 1 0 0 1 -.516.144z" />
                    <path d="m28.7 72h-.072a1 1 0 0 1 -.894-.74l-6.178-23.184a1 1 0 1 1 1.931-.515l5.438 20.389 7.488-17.435a1 1 0 1 1 1.838.789l-8.629 20.096a1 1 0 0 1 -.922.6z" />
                    <path d="m28.709 72a1 1 0 0 1 -.736-1.677l16.092-17.515a1 1 0 0 1 1.473 1.354l-16.093 17.515a1 1 0 0 1 -.736.323z" />
                  </svg>
                </div>
                <h3 className="info__title">Increase Job Placements</h3>
                <p className="info__text">
                  Aim to double our placement numbers by partnering with more
                  companies and industries.
                </p>
              </div>
              {/* end info-box */}
            </div>
            {/* end col-lg-3 */}
            <div className="col-lg-3 responsive-column-half">
              <div className="info-box" style={{ height: 450 }}>
                <div className="info-overlay" />
                <div className="icon-element mx-auto shadow-sm">
                  <svg
                    className="svg-icon-color-3"
                    viewBox="0 0 74 74"
                    width={50}
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m23.8 23.84a1 1 0 0 1 -.294-1.956l5.96-1.84a1 1 0 0 1 .59 1.912l-5.956 1.844a.981.981 0 0 1 -.3.04z" />
                    <path d="m37 43.84a1.009 1.009 0 0 1 -.37-.071l-34-13.561a1 1 0 0 1 .07-1.883l5.29-1.64a1 1 0 0 1 .592 1.91l-2.592.8 31.01 12.368 25.9-10.325a1.015 1.015 0 0 1 .12-.057l4.98-1.981-31-9.593-2.165.669a1 1 0 1 1 -.59-1.912l2.46-.76a1 1 0 0 1 .59 0l34 10.52a1 1 0 0 1 .075 1.884l-7.49 2.982a.95.95 0 0 1 -.12.058l-26.39 10.521a1.009 1.009 0 0 1 -.37.071z" />
                    <path d="m13.069 27.161a1 1 0 0 1 -.3-1.956l5.951-1.841a1 1 0 1 1 .59 1.911l-5.95 1.841a1.013 1.013 0 0 1 -.291.045z" />
                    <path d="m16.8 47.849a1 1 0 0 1 -1-1v-12.064a1 1 0 1 1 2 0v12.064a1 1 0 0 1 -1 1z" />
                    <path d="m57.188 47.849a1 1 0 0 1 -1-1v-12.064a1 1 0 0 1 2 0v12.064a1 1 0 0 1 -1 1z" />
                    <path d="m37 56.239c-11.884 0-21.193-4.123-21.193-9.386a1 1 0 1 1 2 0c0 3.493 7.882 7.386 19.193 7.386s19.193-3.893 19.193-7.386a1 1 0 1 1 2 0c0 5.263-9.309 9.386-21.193 9.386z" />
                    <path d="m63.393 44.387a1 1 0 0 1 -1-1v-10.2l-25.529-3.5a1 1 0 1 1 .272-1.982l26.393 3.615a1 1 0 0 1 .864.991v11.076a1 1 0 0 1 -1 1z" />
                    <path d="m66.406 49.5h-5.687a1 1 0 0 1 -.978-1.211l.736-3.411a3.156 3.156 0 0 1 6.171 0l.736 3.411a1 1 0 0 1 -.978 1.211zm-4.448-2h3.209l-.474-2.2a1.157 1.157 0 0 0 -2.261 0z" />
                  </svg>
                </div>
                <h3 className="info__title">Innovate Training Delivery</h3>
                <p className="info__text">
                  Incorporate new technologies like virtual reality and
                  e-learning platforms to enhance the training experience.
                </p>
              </div>
              {/* end info-box */}
            </div>
            {/* end col-lg-3 */}
          </div>
          {/* end row */}
        </div>
        {/* end container */}
      </section>
      {/* end feature-area */}
      {/*Service list*/}
      <section className="testimonial-area pt-40px">
        <div className="container">
          <div className="section-heading text-center">
            <h2 className="section__title">Our Services</h2>
            <span className="section-divider" />
          </div>
        </div>

        {/* Carousel wrapper */}
        <>
          {/* Carousel wrapper */}
          <div
            id="carouselMultiItemExample"
            data-mdb-carousel-init=""
            className="carousel slide carousel-dark text-center"
            data-mdb-ride="carousel"
          >
            {/* Controls */}
            <div className="d-flex justify-content-center mb-4">
              <button
                data-mdb-button-init=""
                className="carousel-control-prev position-relative"
                type="button"
                data-mdb-target="#carouselMultiItemExample"
                data-mdb-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                />
                <span className="visually-hidden">Previous</span>
              </button>
              <button
                data-mdb-button-init=""
                className="carousel-control-next position-relative"
                type="button"
                data-mdb-target="#carouselMultiItemExample"
                data-mdb-slide="next"
              >
                <span
                  className="carousel-control-next-icon "
                  aria-hidden="true"
                />
                <span className="visually-hidden">Next</span>
              </button>
            </div>
            {/* Inner */}
            <div className="carousel-inner py-4">
              {/* Single item */}
              <div className="carousel-item active">
                <div className="container">
                  <div className="row gap-4 justify-content-center">
                    <div className="col-lg-5 responsive-column-half py-4">
                      <div
                        className="card card-item hover-y"
                        style={{ height: 250 }}
                      >
                        <div className="card-body align-items-center">
                          <h5 className="mb-3">Vocational Training Programs</h5>
                          <ul class="generic-list-item overview-list-item">
                            <li className="">
                              <i class="la la-circle mr-1 text-black"></i>
                              Offering skill development courses in various
                              sectors like retail, IT, manufacturing,
                              healthcare, and more, aligned with industry
                              standards.
                            </li>
                            <li className="">
                              <i class="la la-circle mr-1 text-black"></i>
                              Curriculum designed to cater to the practical
                              needs of the job market, making students
                              job-ready.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-5 responsive-column-half py-4">
                      <div
                        className="card card-item hover-y"
                        style={{ height: 250 }}
                      >
                        <div className="card-body align-items-center">
                          <h5 className="mb-3">Placement Assistance</h5>
                          <ul class="generic-list-item overview-list-item">
                            <li className="">
                              <i class="la la-circle mr-1 text-black"></i>
                              Dedicated placement cell that works closely with
                              industry partners to facilitate job placements.
                            </li>
                            <li className="">
                              <i class="la la-circle mr-1 text-black"></i>
                              Organizing job fairs and campus recruitment drives
                              to connect trainees with potential employers.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Single item */}
              <div className="carousel-item">
                <div className="container">
                  <div className="row gap-4 justify-content-center">
<div className="col-lg-5 responsive-column-half py-4">
                      <div
                        className="card card-item hover-y"
                        style={{ height: 250 }}
                      >
                        <div className="card-body align-items-center">
                      <h5 className="mb-3">Career Guidance and Counselling</h5>
                      <ul class="generic-list-item overview-list-item">
                        <li className="">
                          <i class="la la-circle mr-1 text-black"></i>
                          Providing students with career counseling to help them
                          choose the right training programs based on their
                          interests and market demand.
                        </li>
                        <li className="">
                          <i class="la la-circle mr-1 text-black"></i>
                          Offering support in resume building, interview
                          preparation, and soft skills development.
                        </li>
                          </ul>
                          </div>
                          </div>
                    </div>
<div className="col-lg-5 responsive-column-half py-4">
                      <div
                        className="card card-item hover-y"
                        style={{ height: 250 }}
                      >
                        <div className="card-body align-items-center">
                      <h5 className="mb-3">Government Initiative Partner</h5>
                      <ul class="generic-list-item overview-list-item">
                        <li className="">
                          <i class="la la-circle mr-1 text-black"></i>
                          As a training partner of PMKVY and JSDM, we align our
                          courses with national skill development initiatives to
                          support government efforts in improving employability.
                        </li>
                      </ul>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Inner */}
          </div>
          {/* Carousel wrapper */}
        </>

        {/* Carousel wrapper */}
      </section>
      {/*======================================
 END FEATURE AREA
======================================*/}
      <div className="container-fluid mb-4">
        <h2 className="section__title mb-3 text-center">Our Mission</h2>
        <div className="row">
          <div className="col-lg-4 responsive-column-half">
            <div className="card card-item hover-y" style={{ height: 300 }}>
              <div className="card-body d-flex align-items-center">
                <div className="flex-shrink-0">
                  <img
                    src="images/small-img-2.jpg"
                    alt="card image"
                    className="img-fluid rounded-full"
                  />
                </div>
                <div className="pl-4">
                  <h5 className="card-title pt-4 pb-2">Empowering Youth</h5>
                  <p className="card-text">
                    We are committed to providing vocational training to
                    unemployed and dropout youth, enabling them to acquire
                    industry-relevant skills.{" "}
                  </p>
                  {/* <div className="btn-box mt-20px">
                    <a href="become-a-teacher.html" className="btn theme-btn theme-btn-sm lh-30"><i className="la la-user mr-1"></i>Start Teaching</a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 responsive-column-half">
            <div className="card card-item hover-y" style={{ height: 300 }}>
              <div className="card-body d-flex align-items-center">
                <div className="flex-shrink-0">
                  <img
                    src="images/small-img-3.jpg"
                    alt="card image"
                    className="img-fluid rounded-full"
                  />
                </div>
                <div className="pl-4">
                  <h5 className="card-title pt-4 pb-2">Driving Employment</h5>
                  <p className="card-text">
                    We work towards improving employability by facilitating job
                    placements through our dedicated placement cell.{" "}
                  </p>
                  {/* <div className="btn-box mt-20px">
                    <a href="for-business.html" className="btn theme-btn theme-btn-sm lh-30"><i className="la la-briefcase mr-1"></i>Get Aduca for Business</a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 responsive-column-half">
            <div className="card card-item hover-y" style={{ height: 300 }}>
              <div className="card-body d-flex align-items-center">
                <div className="flex-shrink-0">
                  <img
                    src="images/small-img-4.jpg"
                    alt="card image"
                    className="img-fluid rounded-full"
                  />
                </div>
                <div className="pl-4">
                  <h5 className="card-title pt-4 pb-2">Nation Building</h5>
                  <p className="card-text">
                    Contributing to India's economic development by enhancing
                    the skills of the workforce and reducing unemployment.{" "}
                  </p>
                  {/* <div className="btn-box mt-20px">
                    <a href="admission.html" className="btn theme-btn theme-btn-sm lh-30"><i className="la la-file-text-o mr-1"></i>Start Learning</a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="cat-area pt-40px pb-40px bg-gray position-relative">
        <span className="ring-shape ring-shape-1" />
        <span className="ring-shape ring-shape-2" />
        <span className="ring-shape ring-shape-3" />
        <span className="ring-shape ring-shape-4" />
        <span className="ring-shape ring-shape-5" />
        <span className="ring-shape ring-shape-6" />
        <span className="ring-shape ring-shape-7" />
        {/* end container */}
        <div className="container text-center">
          <h4 className="ribbon ribbon-lg ">Impact on Society</h4>
          <h4 className="section__desc text-muted mt-2">
            AITSIL SPV PVT. LTD. is not just a training provider; we are a
            social change agent. By equipping the youth with the skills they
            need, we help uplift communities, reduce unemployment, and
            contribute to the nation's economic progress. Our work supports the
            government's vision of "Skill India" by creating a skilled workforce
            that meets the needs of a rapidly evolving economy.
          </h4>
        </div>
      </section>
      {/* end cta-area */}

      <div className="section-block" />
      {/*======================================
  START ABOUT AREA
======================================*/}
      <section className="about-area pt-40px overflow-hidden">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="about-content pb-5">
                <div className="section-heading">
                  <h2 className="section__title">
                    Why Choose AITSIL SPV PVT. LTD.
                  </h2>
                  <span className="section-divider" />
                  <ul class="generic-list-item overview-list-item">
                    <li className="">
                      <i class="la la-check mr-1 text-black"></i>
                      <span className="text-secondary f-w-bold mr-2">
                        <b>Experienced Faculty :</b>
                      </span>
                      Our trainers are industry experts with extensive
                      experience in their respective fields, ensuring that
                      students receive practical, hands-on training.
                    </li>
                    <li className="">
                      <i class="la la-check mr-1 text-black"></i>
                      <span className="text-secondary f-w-bold mr-2">
                        <b>Comprehensive Curriculum :</b>
                      </span>
                      Courses designed with input from industry partners to meet
                      current market needs.
                    </li>
                    <li className="">
                      <i class="la la-check mr-1 text-black"></i>
                      <span className="text-secondary f-w-bold mr-2">
                        <b>High Placement Rate :</b>
                      </span>
                      Strong placement record with a network of industry
                      partners providing job opportunities.
                    </li>
                    <li className="">
                      <i class="la la-check mr-1 text-black"></i>
                      <span className="text-secondary f-w-bold mr-2">
                        <b>Government Accreditation :</b>
                      </span>
                      Partnering with reputable government skill development
                      initiatives ensures recognition and quality training.
                    </li>
                    <li className="">
                      <i class="la la-check mr-1 text-black"></i>
                      <span className="text-secondary f-w-bold mr-2">
                        <b>Focus on Holistic Development: </b>
                      </span>
                      We not only provide technical skills but also emphasize
                      personality development and communication skills.
                    </li>
                  </ul>
                </div>
                {/* end section-heading */}
                {/* <div className="row pt-4 pb-3">
                  <div className="col-lg-4 responsive-column-half">
                    <div className="info-icon-box mb-3">
                      <div className="icon-element icon-element-md shadow-sm">
                        <svg
                          className="svg-icon-color-1"
                          width={32}
                          viewBox="0 0 512 512"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g>
                            <path d="m181.022 142.59-8.659 3.138c-13.364 4.846-23.334 16.536-26.021 30.517l-2.938 15.396c-1.466 7.626.53 15.436 5.479 21.425 4.951 5.995 12.251 9.433 20.025 9.433h75.057c7.714 0 14.977-3.393 19.927-9.309 4.946-5.911 7.004-13.65 5.646-21.233l-2.74-15.315c-2.539-14.201-12.542-26.081-26.108-31.004l-9.18-3.327v-13.53c0-.38-.037-.75-.092-1.115 6.697-6.818 10.533-16.115 10.533-25.627v-20.159c0-19.678-16.01-35.687-35.689-35.687s-35.692 16.009-35.692 35.687v20.787c0 9.778 4.032 18.705 10.515 25.188-.038.304-.063.611-.063.925zm71.008 36.692 2.74 15.317c.574 3.201-.295 6.468-2.384 8.964-2.092 2.5-5.162 3.935-8.423 3.935h-75.057c-3.285 0-6.369-1.452-8.461-3.985-2.088-2.528-2.931-5.823-2.311-9.05l2.938-15.396c1.693-8.812 7.979-16.183 16.4-19.236l5.672-2.055c.142.146.285.293.439.428 6.463 5.651 14.57 8.477 22.682 8.476 8.102 0 16.207-2.82 22.671-8.46.233-.203.447-.422.651-.65l5.983 2.169c8.554 3.102 14.86 10.59 16.46 19.543zm-66.46-97.402c0-11.406 9.281-20.687 20.689-20.687 9.628 0 17.718 6.62 20.015 15.54-.964.471-1.953.916-2.966 1.321-9.222 3.692-16.671 3.202-18.8 1.71-3.392-2.378-8.068-1.558-10.447 1.834-2.378 3.392-1.557 8.068 1.834 10.447 3.663 2.569 8.635 3.853 14.309 3.853 5.155 0 10.89-1.071 16.745-3.19v9.329c0 5.733-2.371 11.347-6.506 15.402-1.914 1.878-4.107 3.333-6.462 4.337-.165.063-.327.131-.486.205-2.419.957-5.003 1.438-7.644 1.369-11.184-.215-20.281-9.494-20.281-20.684zm19.993 56.469c.229.004.456.006.685.006 3.519 0 6.967-.529 10.261-1.544v11.999c-6.251 3.854-14.242 3.852-20.485-.006v-11.971c3.034.919 6.231 1.452 9.539 1.516z"></path>
                            <path d="m88.264 350.904h233.57c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-233.57c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5z"></path>
                            <path d="m88.264 391.345h233.57c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-233.57c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5z"></path>
                            <path d="m88.264 431.784h233.57c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-233.57c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5z"></path>
                            <path d="m88.264 472.225h233.57c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-233.57c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5z"></path>
                            <path d="m80.764 262.524c0 4.143 3.357 7.5 7.5 7.5h233.57c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-233.57c-4.143 0-7.5 3.358-7.5 7.5z"></path>
                            <path d="m88.264 310.464h233.57c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-233.57c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5z"></path>
                            <path d="m60.569 350.932c4.158 0 7.529-3.37 7.529-7.528 0-4.157-3.371-7.528-7.529-7.528s-7.528 3.37-7.528 7.528 3.371 7.528 7.528 7.528z"></path>
                            <path d="m60.569 270.052c4.158 0 7.529-3.37 7.529-7.528s-3.371-7.528-7.529-7.528-7.528 3.37-7.528 7.528 3.371 7.528 7.528 7.528z"></path>
                            <path d="m60.569 310.492c4.158 0 7.529-3.37 7.529-7.528s-3.371-7.528-7.529-7.528-7.528 3.37-7.528 7.528 3.371 7.528 7.528 7.528z"></path>
                            <path d="m60.569 391.372c4.158 0 7.529-3.37 7.529-7.528s-3.371-7.528-7.529-7.528-7.528 3.37-7.528 7.528 3.371 7.528 7.528 7.528z"></path>
                            <path d="m60.569 431.813c4.158 0 7.529-3.37 7.529-7.528s-3.371-7.528-7.529-7.528-7.528 3.37-7.528 7.528c0 4.157 3.371 7.528 7.528 7.528z"></path>
                            <path d="m60.569 472.253c4.158 0 7.529-3.37 7.529-7.528 0-4.157-3.371-7.528-7.529-7.528s-7.528 3.37-7.528 7.528c0 4.157 3.371 7.528 7.528 7.528z"></path>
                            <path d="m485.63 118.121c-3.026-3.83-5.886-7.449-7.269-10.783-1.492-3.599-2.08-8.354-2.702-13.39-1.091-8.822-2.327-18.821-9.305-25.798s-16.978-8.213-25.8-9.304c-5.037-.622-9.794-1.21-13.393-2.702-3.335-1.383-6.953-4.241-10.784-7.268-5.271-4.165-11.068-8.738-17.922-10.813v-2.269c.001-19.736-16.058-35.794-35.797-35.794h-312.444c-19.739 0-35.798 16.058-35.798 35.795v28.949c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-28.949c0-11.467 9.33-20.795 20.798-20.795h312.444c11.468 0 20.798 9.328 20.798 20.795v2.27c-6.852 2.076-12.647 6.647-17.918 10.812-3.831 3.026-7.449 5.885-10.783 7.268-3.599 1.491-8.356 2.079-13.393 2.702-8.822 1.09-18.821 2.326-25.8 9.303-6.979 6.978-8.215 16.977-9.306 25.799-.622 5.035-1.21 9.791-2.702 13.39-1.383 3.334-4.242 6.953-7.269 10.783-5.604 7.091-11.954 15.128-11.954 25.417s6.351 18.326 11.954 25.417c3.026 3.83 5.886 7.449 7.269 10.783 1.492 3.599 2.08 8.354 2.702 13.391 1.091 8.821 2.327 18.82 9.305 25.797 6.978 6.978 16.978 8.213 25.8 9.304 2.63.325 5.179.644 7.532 1.084v113.367c0 4.443 2.48 8.411 6.473 10.355 3.992 1.947 8.645 1.453 12.146-1.288l15.943-12.483v136.94c0 11.467-9.33 20.795-20.798 20.795h-312.443c-11.468 0-20.798-9.328-20.798-20.795v-378.435c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v378.434c0 19.737 16.059 35.795 35.798 35.795h312.444c19.739 0 35.798-16.058 35.798-35.795v-136.94l15.943 12.482c2.081 1.63 4.571 2.466 7.089 2.466 1.716 0 3.444-.389 5.064-1.178 3.994-1.944 6.476-5.912 6.476-10.354v-83.697c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v76.555l-19.937-15.609c-2.015-1.595-4.549-2.474-7.136-2.474s-5.121.879-7.104 2.448l-19.959 15.627v-98.625c.544.426 1.091.857 1.645 1.294 7.092 5.604 15.13 11.953 25.42 11.953 10.289 0 18.327-6.35 25.419-11.952 3.831-3.026 7.45-5.886 10.784-7.269 3.599-1.491 8.356-2.079 13.393-2.702 8.822-1.09 18.821-2.326 25.801-9.303 6.977-6.978 8.213-16.977 9.304-25.798.623-5.036 1.211-9.792 2.703-13.391 1.383-3.334 4.242-6.953 7.269-10.783 5.604-7.091 11.954-15.128 11.954-25.417s-6.351-18.326-11.954-25.417zm-11.769 41.534c-3.528 4.465-7.176 9.081-9.355 14.337-2.273 5.48-3.016 11.487-3.734 17.296-.871 7.046-1.693 13.701-5.023 17.031-3.331 3.33-9.987 4.152-17.034 5.023-5.81.718-11.816 1.46-17.298 3.733-5.256 2.179-9.872 5.826-14.337 9.354-5.679 4.485-11.042 8.723-16.121 8.723s-10.442-4.237-16.121-8.723c-4.465-3.527-9.081-7.175-14.337-9.354-.362-.15-1.618-.628-1.889-.712-4.957-1.724-10.26-2.385-15.41-3.021-7.047-.871-13.703-1.694-17.034-5.024-3.329-3.329-4.152-9.984-5.023-17.029-.718-5.81-1.46-11.815-3.733-17.297-2.18-5.256-5.827-9.872-9.355-14.337-4.485-5.678-8.723-11.04-8.723-16.117s4.237-10.439 8.723-16.117c3.528-4.465 7.176-9.081 9.355-14.337 2.273-5.48 3.016-11.487 3.733-17.296.871-7.046 1.694-13.701 5.024-17.031 3.331-3.33 9.987-4.152 17.034-5.023 5.81-.718 11.816-1.46 17.298-3.733 5.256-2.179 9.872-5.826 14.337-9.354 5.667-4.477 11.021-8.705 16.091-8.721.009 0 .019.001.028.001.01 0 .02-.001.03-.001 5.071.015 10.425 4.244 16.093 8.721 4.465 3.527 9.081 7.175 14.337 9.354 5.481 2.273 11.489 3.016 17.299 3.733 7.047.871 13.703 1.694 17.033 5.024s4.153 9.984 5.024 17.03c.718 5.809 1.46 11.815 3.733 17.296 2.18 5.256 5.827 9.872 9.355 14.337 4.485 5.678 8.723 11.04 8.723 16.117s-4.237 10.44-8.723 16.117z"></path>
                            <path d="m439.109 119.704-25.522-7.221-14.757-22.04c-1.763-2.632-4.705-4.202-7.872-4.202s-6.11 1.571-7.872 4.202l-14.757 22.04-25.524 7.222c-3.048.863-5.452 3.178-6.43 6.19s-.392 6.297 1.566 8.783l16.403 20.843-1.018 26.497c-.123 3.166 1.333 6.168 3.896 8.031 1.645 1.195 3.594 1.813 5.565 1.813 1.102 0 2.21-.193 3.274-.585l24.895-9.158 24.893 9.157c2.973 1.096 6.276.636 8.839-1.225s4.021-4.862 3.899-8.029l-1.018-26.502 16.404-20.843c1.958-2.489 2.543-5.772 1.564-8.784-.975-3.012-3.379-5.326-6.428-6.189zm-24.587 28.143c-1.386 1.764-2.103 3.97-2.018 6.219l.778 20.284-19.053-7.009c-2.111-.777-4.436-.776-6.543-.001l-19.055 7.01.779-20.291c.084-2.241-.634-4.447-2.023-6.217l-12.554-15.952 19.539-5.527c2.161-.613 4.04-1.979 5.289-3.845l11.295-16.87 11.294 16.868c1.25 1.867 3.129 3.233 5.294 3.848l19.535 5.526z"></path>
                          </g>
                        </svg>
                      </div>
                      <h4 className="fs-20 font-weight-semi-bold pt-3">
                        6 Courses
                      </h4>
                    </div>
                  </div>
                  <div className="col-lg-4 responsive-column-half">
                    <div className="info-icon-box mb-3">
                      <div className="icon-element icon-element-md shadow-sm">
                        <svg
                          className="svg-icon-color-2"
                          width={32}
                          viewBox="0 0 512 512"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g>
                            <path d="m499.5 422h-10v-304.92c0-20.678-16.822-37.5-37.5-37.5h-108.332v-27.962c0-28.462-23.156-51.618-51.618-51.618h-72.1c-28.462 0-51.618 23.156-51.618 51.618v27.962h-108.332c-20.678 0-37.5 16.822-37.5 37.5v304.92h-10c-6.893 0-12.5 5.607-12.5 12.5v34.549c0 23.683 19.268 42.951 42.951 42.951h426.098c23.683 0 42.951-19.268 42.951-42.951v-34.549c0-6.893-5.607-12.5-12.5-12.5zm-155.832-307.112h2.347c6.299 0 11.423 5.124 11.423 11.423 0 6.298-5.124 11.422-11.423 11.422h-2.347zm0 37.844h2.347c15.203.011 27.366-12.987 26.36-28.152h72.125v249.151h-18.64v-41.301c0-14.129-4.877-27.975-13.732-38.988-8.856-11.014-21.335-18.751-35.139-21.786l-67.199-14.761c-4.975-1.086-8.438-5.551-8.44-10.494v-12.896c25.347-15.384 42.318-43.248 42.318-75.002zm-144.678 120.228 6.441-1.415c6.113-1.344 11.335-4.877 14.948-9.642l24.143 17.74-15.434 15.434zm29.701 38.208-3.889 62.563h-123.662v-41.301c0-22 15.599-41.398 37.09-46.124l41.257-9.062 43.142 31.702c1.838 1.349 3.941 2.081 6.062 2.222zm57.691-64.029-30.382 22.325-30.382-22.325c.031-.624.058-5.717.033-6.388 9.461 3.502 19.686 5.419 30.35 5.419s20.888-1.917 30.35-5.419c-.013.671-.005 5.765.031 6.388zm-42.032 53.89 11.65-11.65 11.599 11.599 4.258 72.753h-32.027zm23.129-21.385 24.143-17.74c3.613 4.765 8.835 8.298 14.948 9.642l6.44 1.415-30.098 22.118zm21.894 29.3 43.14-31.701 41.256 9.062c21.492 4.726 37.091 24.124 37.091 46.124v41.302h-123.976l-3.662-62.561c2.151-.126 4.287-.857 6.151-2.226zm-106.041-194.309c10.817-.592 21.509-2.153 31.874-4.66 4.026-.974 6.501-5.027 5.527-9.054-.975-4.026-5.026-6.503-9.054-5.526-9.216 2.229-18.722 3.628-28.348 4.202v-47.979c.001-20.191 16.428-36.618 36.619-36.618h72.1c20.191 0 36.618 16.427 36.618 36.618v45.1c-6.201-2.706-12.011-6.201-17.336-10.485-7.358-5.922-13.503-13.088-18.26-21.298-1.673-2.89-4.521-4.86-7.814-5.407-3.288-.544-6.619.398-9.132 2.589-10.05 8.761-21.15 16.144-33.04 21.971-3.719 1.822-5.257 6.315-3.434 10.035 1.821 3.718 6.313 5.258 10.035 3.434 11.728-5.747 22.683-12.825 32.811-21.178 5.302 8.187 11.822 15.419 19.43 21.54 8.063 6.488 17.038 11.5 26.74 14.939v45.645c0 40.069-32.599 72.668-72.668 72.668s-72.668-32.599-72.668-72.668zm27.318 118.869v12.896c-.006 4.93-3.494 9.415-8.439 10.494l-67.201 14.761c-13.803 3.035-26.281 10.772-35.138 21.786-8.855 11.014-13.732 24.859-13.732 38.988v41.302h-18.64v-249.151h72.125c-1.022 15.115 11.132 28.186 26.36 28.152h2.347v5.77c0 31.754 16.971 59.619 42.318 75.002zm-56.087-107.193c0-6.299 5.124-11.423 11.423-11.423h2.347v22.845h-2.347c-6.299-.001-11.423-5.125-11.423-11.422zm342.437 342.738c0 15.412-12.539 27.951-27.951 27.951h-426.098c-15.412 0-27.951-12.539-27.951-27.951v-32.049h190.545v12.5c0 9.649 7.851 17.5 17.5 17.5h65.91c9.649 0 17.5-7.851 17.5-17.5v-12.5h72.043c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-340.998v-304.92c0-12.406 10.094-22.5 22.5-22.5h108.332v5.308h-2.347c-8.226 0-15.584 3.78-20.434 9.692h-81.551c-6.341 0-11.5 5.159-11.5 11.5v260.151c0 4.143 3.357 7.5 7.5 7.5h392c4.143 0 7.5-3.357 7.5-7.5v-260.151c0-6.341-5.159-11.5-11.5-11.5h-81.551c-4.85-5.913-12.208-9.692-20.434-9.692h-2.347v-5.308h108.332c12.406 0 22.5 10.094 22.5 22.5v304.92h-61.002c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h83.502zm-276.455-19.549v-12.5h70.91v12.5c0 1.379-1.121 2.5-2.5 2.5h-65.91c-1.379 0-2.5-1.121-2.5-2.5zm16.377-243.596c5.712 3.132 12.166 4.823 18.662 4.892 8.306.087 15.383-2.637 19.495-4.893 3.632-1.992 4.96-6.551 2.968-10.183s-6.549-4.961-10.183-2.968c-2.545 1.396-6.654 3.045-11.863 3.045-5.146 0-9.343-1.661-11.866-3.046-3.633-1.994-8.191-.661-10.183 2.97-1.991 3.633-.662 8.191 2.97 10.183zm-19.602-52.241c4.143 0 7.5-3.357 7.5-7.5v-15.472c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v15.472c0 4.143 3.358 7.5 7.5 7.5zm77.36 0c4.143 0 7.5-3.357 7.5-7.5v-15.472c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v15.472c0 4.143 3.357 7.5 7.5 7.5z"></path>
                          </g>
                        </svg>
                      </div>
                      <h4 className="fs-20 font-weight-semi-bold pt-3">
                        Live Learning
                      </h4>
                    </div>
                  </div>
                  <div className="col-lg-4 responsive-column-half">
                    <div className="info-icon-box mb-3">
                      <div className="icon-element icon-element-md shadow-sm">
                        <svg
                          className="svg-icon-color-3"
                          width={32}
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          x="0px"
                          y="0px"
                          viewBox="0 0 490.667 490.667"
                          xmlSpace="preserve"
                        >
                          <g>
                            <g>
                              <path
                                d="M245.333,85.333c-41.173,0-74.667,33.493-74.667,74.667s33.493,74.667,74.667,74.667S320,201.173,320,160
                                          C320,118.827,286.507,85.333,245.333,85.333z M245.333,213.333C215.936,213.333,192,189.397,192,160
                                          c0-29.397,23.936-53.333,53.333-53.333s53.333,23.936,53.333,53.333S274.731,213.333,245.333,213.333z"
                              ></path>
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M394.667,170.667c-29.397,0-53.333,23.936-53.333,53.333s23.936,53.333,53.333,53.333S448,253.397,448,224
                                          S424.064,170.667,394.667,170.667z M394.667,256c-17.643,0-32-14.357-32-32c0-17.643,14.357-32,32-32s32,14.357,32,32
                                          C426.667,241.643,412.309,256,394.667,256z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M97.515,170.667c-29.419,0-53.333,23.936-53.333,53.333s23.936,53.333,53.333,53.333s53.333-23.936,53.333-53.333
                                          S126.933,170.667,97.515,170.667z M97.515,256c-17.643,0-32-14.357-32-32c0-17.643,14.357-32,32-32c17.643,0,32,14.357,32,32
                                          C129.515,241.643,115.157,256,97.515,256z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M245.333,256c-76.459,0-138.667,62.208-138.667,138.667c0,5.888,4.779,10.667,10.667,10.667S128,400.555,128,394.667
                                          c0-64.704,52.629-117.333,117.333-117.333s117.333,52.629,117.333,117.333c0,5.888,4.779,10.667,10.667,10.667
                                          c5.888,0,10.667-4.779,10.667-10.667C384,318.208,321.792,256,245.333,256z"
                              ></path>
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M394.667,298.667c-17.557,0-34.752,4.8-49.728,13.867c-5.013,3.072-6.635,9.621-3.584,14.656
                                          c3.093,5.035,9.621,6.635,14.656,3.584C367.637,323.712,380.992,320,394.667,320c41.173,0,74.667,33.493,74.667,74.667
                                          c0,5.888,4.779,10.667,10.667,10.667c5.888,0,10.667-4.779,10.667-10.667C490.667,341.739,447.595,298.667,394.667,298.667z"
                              ></path>
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M145.707,312.512c-14.955-9.045-32.149-13.845-49.707-13.845c-52.928,0-96,43.072-96,96
                                          c0,5.888,4.779,10.667,10.667,10.667s10.667-4.779,10.667-10.667C21.333,353.493,54.827,320,96,320
                                          c13.675,0,27.029,3.712,38.635,10.752c5.013,3.051,11.584,1.451,14.656-3.584C152.363,322.133,150.741,315.584,145.707,312.512z"
                              ></path>
                            </g>
                          </g>
                        </svg>
                      </div>
                      <h4 className="fs-20 font-weight-semi-bold pt-3">
                        Expert Teachers
                      </h4>
                    </div>
                  </div>
                </div> */}
                {/* end row */}
                {/* end btn-box */}
              </div>
              {/* end about-content */}
            </div>
            {/* end col-lg-6 */}
            {/* <div className="col-lg-5 ml-auto">
              <div className="generic-img-box">
                <img
                  src="images/img-loading.png"
                  data-src="images/img13.jpg"
                  alt="About image"
                  className="img__item img__item-1 lazy"
                />
                <img
                  src="images/img-loading.png"
                  data-src="images/img14.jpg"
                  alt="About image"
                  className="img__item img__item-2 lazy"
                />
              </div>
            </div> */}
            {/* end col-lg-5 */}
          </div>
          {/* end row */}
        </div>
        {/* end container */}
      </section>
      {/* end about-area */}
      {/*======================================
  END ABOUT AREA
======================================*/}
      <div className="section-block" />
      {/*======================================
  START REGISTER AREA
======================================*/}
      {/* end register-area */}
      {/*======================================
  END REGISTER AREA
======================================*/}
      <div className="section-block" />

      {/* partner */}
      <section class="register-area section-padding dot-bg overflow-hidden">
        <div class="container">
          <div class="row">
            <div class="col-lg-5">
              <div class="card card-item">
                <div class="card-body">
                  <h3 class="fs-24 font-weight-semi-bold pb-2">
                    Company Details
                  </h3>
                  <div class="divider">
                    <span></span>
                  </div>
                  <ul class="generic-list-item overview-list-item">
                    <li className="">
                      <i class="la la-circle mr-1 text-black"></i>
                      <span className="text-secondary f-w-bold mr-2">
                        <b>Company Name :</b>
                      </span>
                      AITSIL SPV PVT. LTD.
                    </li>
                    <li className="">
                      <i class="la la-circle mr-1 text-black"></i>
                      <span className="text-secondary f-w-bold mr-2">
                        <b>Type :</b>
                      </span>
                      Private Limited Company
                    </li>
                    <li className="">
                      <i class="la la-circle"></i>
                      <span className="text-secondary f-w-bold mr-2">
                        <b>industry :</b>
                      </span>
                      Vocational Training, Skill Development, Education
                    </li>
                    <li className="">
                      <i class="la la-circle"></i>
                      <span className="text-secondary f-w-bold mr-2">
                        <b>Headquarters :</b>
                      </span>
                      C-Block 1st Floor , Deval Gurukrupa Ghatlodiya Ahmedabad
                      Gujarat 382481
                    </li>
                    <li className="">
                      <i class="la la-circle"></i>
                      <span className="text-secondary f-w-bold mr-2">
                        <b>Established :</b>
                      </span>
                      2019
                    </li>
                    <li className="d-flex justify-content-start">
                      <i class="la la-circle"></i>
                      <span className="text-secondary f-w-bold mr-2">
                        <b>Website :</b>
                      </span>
                      <a
                        href="https://www.aitsil.in"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        www.aitsil.in
                      </a>
                      {/* 
                      <Link target="_blank" to="www.aitsil.in">
                        www.aitsil.in
                      </Link> */}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-6 ml-auto">
              <div class="register-content">
                <div class="section-heading">
                  <h5 class="ribbon ribbon-lg mb-2">Partner with Us</h5>
                  <h2 class="section__title">
                    Get ahead with Learning Paths. Stay Sharp.
                  </h2>
                  <span class="section-divider"></span>
                  <p class="section__desc">
                    AITSIL SPV PVT. LTD. is always open to collaborating with
                    government agencies, corporate partners, and NGOs to expand
                    the reach of skill development initiatives and contribute to
                    the socioeconomic development of the country. Together, we
                    can make a difference.{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CompanyDetails;
